import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const VENN_DIAGRAM_ACTIVITY_FRAGMENT = gql `
  fragment VennDiagramActivityFragment on VennDiagramActivity {
    rounds {
      vennDiagramOptionalImage: optionalImage {
        image {
          ...AssetFragment
        }
      }
      position
      steps {
        answer
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default VENN_DIAGRAM_ACTIVITY_FRAGMENT;
